export default __webpack_public_path__ + "static/commmune_kpi_encyclopedia-396655fdd30d1077bff40258a8aa5ac7.jpg";